import * as firebase from 'firebase/app';
import 'firebase/storage';
import * as uuid from 'uuid/v4';
import { i18n } from '@shared/i18n';
import filesize from 'filesize';

export class FileUploader {
  static validate(file, schema) {
    if (!schema) return;

    const thisFile = 'raw' in file ? file.raw : file;
    const { type } = thisFile;

    if (
      schema.formats &&
      !schema.formats.includes(type)
    ) {
      throw new Error(
        i18n(
          'fileUploader.formats',
          schema.extensions.map(f => f.toUpperCase()).join('/'),
        ),
      );
    }

    if (schema.image) {
      if (!thisFile.type.startsWith('image')) {
        throw new Error(i18n('fileUploader.image'));
      }
    }

    if (schema.size && thisFile.size > schema.size) {
      throw new Error(
        i18n('fileUploader.size', filesize(schema.size)),
      );
    }
  }

  /**
   * 
   * @param {*} path: String
   * @param {*} request: Objec
   * @param {*} schema: Object
   * @param {*} addIdPath: Boolean  Indica si se añade el id al path del storage
   */
  static uploadFromRequest(path, request, schema, { addIdToPath = false } = {}, callback) {
    try {
      FileUploader.validate(request.file, schema);
    } catch (error) {
      request.onError(error);
      if (typeof callback === 'function') callback(error);
      return;
    }

    const ref = firebase.storage().ref();
    var pathTemp = `${path}`;///${fileName}`
    const id = uuid();
    
    if (addIdToPath) {
      pathTemp = `${path}/${id}`
    }

    const fileType = request.file.type;
    const fileName = request.file.name;
    const fullPath = pathTemp + "/" + fileName;
    const task = ref.child(fullPath).put(request.file);

    task.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      (snapshot) => {
        const percent =
          (snapshot.bytesTransferred /
            snapshot.totalBytes) *
          100;

        setTimeout(() => {
          request.onProgress({ percent });
        }, 0);
      },
      (error) => {
        request.onError(error);
        if (typeof callback === 'function') callback(error);
      },
      () => {
        task.snapshot.ref
          .getDownloadURL()
          .then((url) => {
            request.onSuccess({
              id: id,
              name: fileName,
              type: fileType,
              sizeInBytes: task.snapshot.totalBytes,
              privateUrl: pathTemp + "/",
              publicUrl: url,
              new: true,
            });
            if (typeof callback === 'function') callback();
          })
          .catch((error) => {
            request.onError(error);
            if (typeof callback === 'function') callback(error);
          });
      },
    );
  }
}
